import React, { Component } from 'react';
import { Modal, Notification, FileUploader } from 'carbon-components-react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { TableDefault, Breadcrumb } from '../../../../components';
import { insertDmService, getByDmService, getDmService } from '../../../../services/Api';
import appConfig from '../../../../config/app-config';
import { forceDownload } from '../../../../lib/validations';

const {IMAGE_PATH} = appConfig;

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      page: 1,
      type: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: '/TagPreco',
      urlEdit: '/admin/tags/produto/editar/',
      urlLoad: '/TagPreco/GetListagem/',
      modalImportacao:false,
      modalExportacao:false,
      fornecedores:[],
      fornecedorSelecionado: {label:"Todos", id:0}
    };
  }

  componentWillMount = async() => {
    await this.loadFornecedor();
  }

  create = () => {
    const { history } = this.props;
    const urlGo ='/admin/tags/produto/editar';
    history.push(urlGo);
  };

  importarModal = () => {
    this.setState(prevState => ({modalImportacao:!prevState.modalImportacao}))
  };

  exportarModal = () => {
    this.setState(prevState => ({modalExportacao:!prevState.modalExportacao}))
  };

  importar = async() => {
    const { file } = this.state;
    if(file) {
      try {
        const data = new FormData();
        data.append('file', file);
        await insertDmService(`/TagPreco/Upload`, data);
        this.setState({erro:""})
        toast.success("Importação concluída");
        this.importarModal();
      } catch (err) {
        this.errorHandler(err);
      }
    } else {
      toast.warn('Selecione um arquivo');
    }
  };

  errorHandler = err => {
    if (err.error && typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      this.setState({erro:error.trim()}) 
    } if(err.message)
      this.setState({erro:err.message}) 
    else {
      this.setState({erro:'Ocorreu um erro ao importar os dados, tente novamente mais tarde'});
    }
  };
  
  fileChange = async (e, name) => {
    const { files } = document.getElementsByName(name)[0];
    if (files.length > 0) {
      this.setState({file:files[0], erro:null, arquivo:files[0].name})
      this.fileUploader.clearFiles();
    }
  };

  
  loadFornecedor = async () => {
    try {
      const data = await getDmService('/Fornecedor');
      const fornecedores = data.map(item => ({label:item.nomeFantasia, id:item.id}));
      this.setState({ fornecedores: [{label:"Todos", id:0}, ...fornecedores] });
    } catch (error) {
      console.error(error);
    }
  }

  onChangeFornecedor = fornecedor => {
    this.setState({fornecedorSelecionado:fornecedor})
  };

  exportar = async(tipo) => {
    try {
      const {fornecedorSelecionado} = this.state;
      const {id} = fornecedorSelecionado || {id:0}
      const data = await getByDmService('/TagPreco/Exportar', `?tipo=${tipo}&fornecedor=${id}`);
      forceDownload(IMAGE_PATH + data);
    } catch (error) {
      toast.error('Ocorreu uma falha ao gerar o arquivo');
    }
  }

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      type,
      modalImportacao,
      erro,
      modalExportacao,
      fornecedores,
      fornecedorSelecionado,
      arquivo
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title='Tags (Produtos Agência)'
          description='Gerencie Tags de Produtos Agência.'
          renderRight={(() => (
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={this.create}
              >
                Criar Tag
              </button>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={this.importarModal}
              >
                Importar Tags
              </button>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={this.exportarModal}
              >
                Exportar Preço
              </button>
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.exportar('todastags')}
              >
                Exportar Tags
              </button>              
            </div>
          ))()}
        />
        <section className="content-wrapper screen-table-tags">
          <TableDefault
            search={search}
            type={type}
            order={order}
            orderBy={orderBy}
            page={page}
            pageSize={pageSize}
            totalItems={totalItems}
            urlDelete={urlDelete}
            urlEdit={urlEdit}
            urlLoad={urlLoad}
            onRef={ref => (this.tableList = ref)}
          />
        </section>

        <Modal
          modalHeading="Importar Tags"
          primaryButtonText="Importar"
          secondaryButtonText="Cancelar"
          onRequestSubmit={() => this.importar()}
          onRequestClose={() => this.importarModal()}
          open={modalImportacao}
          className="component-quatity-sizes-modal"
        >
          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-md-12">
              <FileUploader
                labelTitle=""
                labelDescription=" Arquivo Excel no formato xlsx "
                buttonLabel="Arquivo"
                filenameStatus="edit"
                onChange={async e => {
                  await this.fileChange(e, 'arquivo');
                }}
                buttonKind="secondary"
                multiple={false}
                ref={fileUploader => (this.fileUploader = fileUploader)}
                accept={['.xlsx']}
                name="arquivo"
              />
              {arquivo}
            </div>
          </div>
          {erro && (
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-md-12">
                <Notification
                  kind="warning"
                  className="animated rubberBand delay-5s"
                  role="alert"
                  title="Falha ao importar o arquivo"
                  onCloseButtonClick={() => this.closeNotification()}
                  subtitle=""
                  iconDescription="describes the close button"
                />
                {Array.isArray(erro) && (
                  <ul>
                    {erro.map(item => (
                      <li>{item}</li>
                    ))}
                  </ul>
                )}
                {!Array.isArray(erro) && (
                  <p>{erro}</p>
                )}
              </div>
            </div>
          )}
        </Modal>

        <Modal
          modalHeading="Exportar Tags"
          primaryButtonText="Fechar"
          onRequestClose={() => this.exportarModal()}
          open={modalExportacao}
          className="medium-modal"
          passiveModal="true"
        >
          <div style={{paddingBottom:"20px",paddingTop:"20px"}}>
            <p>Exportar por fornecedor</p>
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-md-12">
                <Select
                  className="search-dm"
                  name="fornecedor"
                  required
                  options={fornecedores}
                  value={fornecedorSelecionado}
                  onChange={this.onChangeFornecedor}
                  placeholder="Selecione um fornecedor"
                  isClearable={false}
                  isSearchable
                />
              </div>
            </div>
          </div>
          <div className="bx--row" style={{paddingBottom:"20px",paddingTop:"20px"}}>
            <div className="bx--col-xs-12 bx--col-md-6">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.exportar('todos')}
              >
                Exportar preços atuais
              </button>
            </div>
            <div className="bx--col-xs-12 bx--col-md-6">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.exportar('historico')}
              >
                Exportar histórico de preços
              </button>
            </div>         
          </div>
        </Modal>

      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/ManageTags/List.js